export default {
    age: [
        '20-30',
        '30-40',
        '40-50',
        '50-60',
        '60+',
    ],
    firmSize: [
        '0-9',
        '10-49',
        '50-100',
        '100+',
    ]
}